import React, { useEffect, useState } from "react";
import "antd/dist/antd";
import "../../Onboarding/Onboarding.scss";
import OnboardingTasks from "./OnboardingTasks";
import { Button, Card, Modal } from "antd";
import useOnboardingProcess from "Hooks/AdminHooks/useOnboardingProcess";

const HiringOnboarding = () => {
const {
  formData,
  setFormData,
  handleSubmit,
  handleNavigation,
  isCompleted,
  loading,
  handleCheckboxChange
} = useOnboardingProcess();
  const [isModalVisible, setIsModalVisible] = useState(false);

if (loading) return <p>Loading...</p>;
  return (
    <>
    
      <Modal open={isCompleted} closable={false} footer={null} centered>
  <p style={{ textAlign: "center", fontSize: "18px" }}>
    You have already completed onboarding
  </p>

  <Button className="btn-primary" onClick={handleNavigation}>
    Personal Info
  </Button>
</Modal>
      {!isCompleted && (
  <Card title="New Hiring Onboarding Checklists" className="card-professional">
   <OnboardingTasks
  formData={formData}
  setFormData={setFormData}
  isCompleted={isCompleted}
  handleCheckboxChange={handleCheckboxChange} 
/>

    <Button
      className="btn-primary"
      style={{ float: "inline-end" }}
      onClick={handleSubmit}
    >
      Save
    </Button>
  </Card>
)}
    </>
  );
};

export default HiringOnboarding;
